import Vue from 'vue';
import Fragment from 'vue-fragment';
import '@/registerServiceWorker';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import plugins from '@/plugins';
import { i18n } from '@/i18n';
import ContextGetter from '@/router/context-getter';
import constants from '@/plugins/vue-constants/constants';
import VueMatomo from '../public/js/matmo/matmo';

// plugins install
// [CAUTION] plugins instanced ordered:
// Events plugin instances a global bus that can be used later by other plugins
Vue.use(plugins.Events);
const globalBus = Vue.events.global();

Vue.use(plugins.VueConstants);

const apiClientBaseUrl = (process.env.NODE_ENV === 'development' ? '/' : ContextGetter.getContext()) + process.env.VUE_APP_BASE_REST_URL;
console.log(`vue.init.js ${apiClientBaseUrl}`);
Vue.use(plugins.ApiClient, {
  baseURL: apiClientBaseUrl,
  eventBus: globalBus,
});

Vue.use(plugins.VueDate);

Vue.use(plugins.VueDebounce);
Vue.use(plugins.VueThrottle);

Vue.config.productionTip = false;

/* Vue.use(VueMatomo, {
  host: constants.piwik.host,
  siteId: constants.piwik.id,
  trackerFileName: 'piwik',
  router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  debug: false,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: [],
}); */

Vue.use(VueMatomo, {
  host: constants.matomo.host,
  siteId: window.flutter_inappwebview ? constants.matomo.siteIdApp : constants.matomo.siteId,
  trackerFileName: 'matomo',
  router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  debug: false,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: [],
});

const { vuetify } = plugins;

router.enableSessionControl(globalBus);

Vue.use(Fragment.Plugin);

export default Vue;
export {
  i18n,
  router,
  store,
  vuetify,
  App,
};
